import configuredAxios from 'helpers/configuredAxios'

const fetchSitemap = (url) => {
  const formData = new FormData()
  formData.append("url", url)

  const axios = configuredAxios('job')
  const data = axios.post(`sitemap/job-search-url`, formData)
    .then(res => res.data.data)
    .catch(error =>
      console.error("Post sitemap Error:", error)
    )

  return data ?? {}
}

export function convertUrl(originalUrl, baseUrl) {
  try {
    const urlObj = new URL(originalUrl, baseUrl);
    const pathParts = urlObj.pathname.split('/').filter(part => part !== '');
    const jobSearchIndex = pathParts.indexOf('jobs-hiring');

    if (jobSearchIndex === -1) return new URL("/en-us/jobs-hiring/job-search", baseUrl);

    // 提取路径参数并转换为键值对
    const params = {};
    const paramPairs = pathParts.slice(jobSearchIndex + 2);

    for (let i = 0; i < paramPairs.length; i += 2) {
      if (i + 1 >= paramPairs.length) break;

      let key = paramPairs[i];
      let value = paramPairs[i + 1];

      // 移除可能的 .html 后缀
      if (value.endsWith('.html')) {
        value = value.slice(0, -5);
      }

      params[key] = value;
    }

    // 构建新路径
    const newPath = '/' + pathParts.slice(0, jobSearchIndex + 2).join('/');
    urlObj.pathname = newPath;

    // 替换查询参数
    const newSearchParams = new URLSearchParams(params);
    urlObj.search = newSearchParams.toString();
    return urlObj.toString();
  } catch (error) {
    console.error('Error processing URL:', error);
    return new URL("/en-us/jobs-hiring/job-search", baseUrl)
  }
}

export function convertToHtmlUrl(originalUrl) {
  try {
    const urlObj = new URL(originalUrl, location.origin);
    const pathParts = urlObj.pathname.split('/').filter(part => part !== '');
    const jobsHiringIndex = pathParts.indexOf('jobs-hiring');

    if (jobsHiringIndex === -1) return originalUrl;

    const params = Object.fromEntries(urlObj.searchParams.entries());
    const paramSegments = [];

    for (const [key, value] of Object.entries(params)) {
      paramSegments.push(
        key,
        value
      );
    }

    // 构建新路径
    const basePath = pathParts.slice(0, jobsHiringIndex + 2);
    let newPathSegments = [...basePath, ...paramSegments];

    if (newPathSegments[newPathSegments.length - 1] === 'index.html') {
      newPathSegments.pop();
    }

    // 确保最后一个 segment 包含 .html
    const lastSegment = newPathSegments[newPathSegments.length - 1] || '';
    if (!lastSegment.endsWith('.html') && newPathSegments.length > 0) {
      newPathSegments[newPathSegments.length - 1] += '.html';
    }

    // 构建完整URL
    urlObj.pathname = '/' + newPathSegments.join('/');
    urlObj.search = '';

    const sitemapUrl = urlObj.toString()
      .replace(/([^:]\/)\/+/g, '$1')
      .replace(/\/$/, '');

    sitemapUrl?.length && fetchSitemap(sitemapUrl)
  } catch (error) {
    console.error('Error processing URL:', error);
    return originalUrl;
  }
}